import {IPricesAddress, IPricesAddressRegion} from "../types/IPricesAddress";

export const getAddressStatsRegion = (address: IPricesAddress): IPricesAddressRegion => address.estate ?? address.district ?? address.city;
import {IPricesAddress, IPricesAddressRegion} from "../types/IPricesAddress";

export const getAddressStatsRegion = (address: IPricesAddress): IPricesAddressRegion => address.estate ?? address.district ?? address.city;
